export default {
    name: 'leave',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        leaveTypes: async (context) => {
            return axios.get(`${synergy4}leave/leaveTypes`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        leaveRequests: async (context,payload) => {
            const range = context.getters.getGlobalDateRange;
            return axios.get(`${synergy4}leave/Leave-details?managerId=${payload.userID}&userId=${payload.userID}&from=${range.from}&to=${range.to}&status=${payload.status}&LeaveType=${payload.leaveType}`)
                .then(({data})=> data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        leave: async (context,payload) => {
            return axios.post(  `${synergy4}leave`,payload)
                .catch((err) => errorHandler.tomcatError(err))
        },

        leaveApprove: async (context,id) => {
            return axios.post(  `${synergy4}leave/approve/${id}`)
                .catch((err) => errorHandler.tomcatError(err))
        },

        leaveDecline: async (context,{id,reason}) => {
            return axios.post(  `${synergy4}leave/decline/${id}?declineReason=${reason}`)
                .catch((err) => errorHandler.tomcatError(err))
        },
    }
}
